import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BackArrow from '../assets/images/Frame_18177.png'
import InactivityTimer from './InactivityTimer';

const PaymentCancel = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const error = query.get('error') || 'Payment was cancelled.';

  return (
    <>
      <InactivityTimer />
      <div className="p-6">
        <div className="flex items-center mb-6">
          <Link
            to="/login"
            className="flex w-28 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
            style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
          >
            <img src={BackArrow} alt="Back" className="mr-2 w-6 h-6" />
            Login
          </Link>
          <span
            className="ml-4 text-2xl font-semibold"
            style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}
          >
            Payment Cancelled
          </span>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4 text-yellow-500">Payment Cancelled</h2>
          <p className="text-yellow-500 mb-4">{decodeURIComponent(error)}</p>
          <Link
            to="/book-appointment"
            className="px-4 py-2 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
            style={{ fontFamily: 'Roboto', fontSize: '16px' }}
          >
            Try Again
          </Link>
        </div>
      </div>
    </>
  );
};

export default PaymentCancel;